var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"flex"},[_c('div',{staticClass:"fit row wrap wrapper"},[_c('div',{staticClass:"col-12"},[_c('q-card',{staticClass:"main__content"},[_c('LoanList')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }